import { Divider, Empty } from 'antd';

import { Table } from '@atom/table/table';
import { PaginationCursor } from '@component/pagination/pagination-cursor';
import { LogsFilter } from '@component/tables/log-filter/logs-filter';
import { isExist, isString } from '@util/data/is-exist';

import { requestLogsColumns } from './request-logs.options';
import { requestSubLogs } from './request-sub-logs/request-sub-logs';
import { useRequestLogs } from './use-request-logs.hook';

interface RequestLogsProps {
  isLoading?: boolean;
  currentConsumerId?: string;
}

export const RequestLogs = ({ isLoading, currentConsumerId }: RequestLogsProps) => {
  const { data, isLoading: isLoadingLogs, pagination, onNext, onPrevious, onChangeFilter } = useRequestLogs();

  return (
    <>
      <LogsFilter onChange={onChangeFilter} />
      <Divider />
      <Table
        columns={requestLogsColumns}
        dataSource={data}
        expandable={{ expandedRowRender: requestSubLogs }}
        loading={isLoading || isLoadingLogs}
        pagination={false}
        rowKey='id'
        footer={
          isExist(pagination)
            ? () => <PaginationCursor pagination={pagination} onNext={onNext} onPrevious={onPrevious} />
            : undefined
        }
        locale={{
          emptyText: (
            <Empty
              description={isString(currentConsumerId) ? 'No logs' : 'Select consumer'}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
            />
          ),
        }}
      />
    </>
  );
};
